import { DateFormats, DateUtil } from "utilities/date-utilities";

type DateViewPropsType = {
    date: Date | undefined | null;
    endDate?: Date;
    format?: DateFormats,
    className?: string,
    separator?: string
}

const DateView = (props: DateViewPropsType) => {
    const format = props.format || DateFormats.SHORT;

    if(!props.date) {
        return <span>-</span>;
    }

    return (
        <span className={props.className}>{DateUtil.format(new Date(props.date), format)}{props.endDate ? ` ${props.separator || '-'} ${DateUtil.format(new Date(props.endDate), format)}` : ''}</span>
    );
};

export default DateView;
